import http from '../utils/http'

//获取站点信息
export function getSiteInfo(params) {
    return http.get(`/api/siteInfo`,params)
}

//获取新闻列表
export function getNewsList(params) {
    return http.get(`/api/article/list/1`,params)
}

//获取新闻详情
export function getNewsInfo(params) {
    return http.get(`/api/article/details/`+params,params)
}

//关于我们
export function aboutUs(params) {
    return http.get(`/api/article/details/3`,params)
}

//企业介绍
export function aboutCompany(params) {
    return http.get(`/api/article/details/7`,params)
}

//搜索订单
export function searchOrder(params){
    //return http.get(`/api/client/order/logisticsInformation`,params)
    return http.get(`api/shipping/tracking`,params)
}

//联系我们
export function contactUs(params){
    return http.get(`/api/article/details/4`,params)
}